import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    ipPhoneList: [],
    ipPhonePermission: [],
}
const mutations = {
    CLEAR_IPPHONE_STATE(state) {
        state.ipPhoneList = [];
        state.ipPhonePermission = [];
    },
    SET_IPP_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.ipPhonePermission = userData.permissions;
        state.ipPhoneList = [];

        if (parseData != null) {
            tData[userData.accountId + '-ipPhoneList'] = parseData;
            state.ipPhoneList = tData;
        }
    },
    DELETE_IPP_LIST(state, data) {
        var ippIds = data.ippData;
        var accountId = data.accountId;
        if (Object.keys(state.ipPhoneList).length != 0) {
            var index = state.ipPhoneList[accountId + "-ipPhoneList"].findIndex(ipphone => ipphone.SetTopPhone.id == ippIds);
            if (index != -1) {
                state.ipPhoneList[accountId + "-ipPhoneList"].splice(index, 1);
            }
        }
    },
    ADD_IPP_LIST(state, data) {
        var ipPhoneData = data.ippData;
        var idx = data.idx;
        var userId = data.userId;
        var accountId = data.accountId;
        if (Object.keys(state.ipPhoneList).length != 0 && state.ipPhoneList != 'noData') {
            if (state.ipPhoneList != 'noData') {
                state.ipPhoneList[accountId + "-ipPhoneList"].push(ipPhoneData);
                state.ipPhoneList[accountId + '-ipPhoneList'][idx].SetTopPhone.user_id = userId;
                state.ipPhoneList[accountId + '-ipPhoneList'][idx].SetTopPhone.account_id = accountId;
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-ipPhoneList"] = ipPhoneData;
            state.ipPhoneList = dataSet;
        }
    },
    ADD_DELETE_IPP_LINK_MAC(state, data) {
        var id = data.id;
        var val = data.val;
        var accountId = data.accountId;
        if (Object.keys(state.ipPhoneList).length != 0 && state.ipPhoneList != 'noData') {
            var index = state.ipPhoneList[accountId + "-ipPhoneList"].findIndex(ipphone => ipphone.SetTopPhone.id == id);
            if (index != -1) {
                state.ipPhoneList[accountId + '-ipPhoneList'].splice(index, 1);
            } else {
                var idx = Object.keys(state.ipPhoneList).length;
                state.ipPhoneList[accountId + '-ipPhoneList'].push(val);
            }
        }
    },
    LINK_IPP_TO_USER(state, data) {
        var id = data.id;
        var type = (data.linkType == false) ? false : true;
        var accountId = data.accountId;
        var userName = data.userName;
        var userId = data.userId;
        if (Object.keys(state.ipPhoneList).length != 0 && state.ipPhoneList != 'noData') {
            var index = state.ipPhoneList[accountId + "-ipPhoneList"].findIndex(ipphone => ipphone.SetTopPhone.id == id);
            if (index != -1) {
                state.ipPhoneList[accountId + '-ipPhoneList'][index].link = type;
                state.ipPhoneList[accountId + '-ipPhoneList'][index].User.username = userName;
                state.ipPhoneList[accountId + '-ipPhoneList'][index].SetTopPhone.user_id = userId;
                state.ipPhoneList[accountId + '-ipPhoneList'][index].SetTopPhone.account_id = accountId;
            }
        }
    },
}
const actions = {
    clearIPPhoneState({
        commit,
        dispatch
    }) {
        commit('CLEAR_IPPHONE_STATE')
    },
    fetchIPPList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/ipphone/get_setTopPhone_data/' + authData.ipphoneName + "/" + authData.ippStatus + "/" + authData.billedStatus + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.sorting)
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit('SET_IPP_LIST', res.data)
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    fetchUserIPPList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/users/user_stphone_data/1', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    commit('SET_IPP_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchIPPPostList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/ipphone/get_setTopPhone_data/' + authData.ipphoneName + "/" + authData.ippStatus + "/" + authData.billedStatus + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.sorting, qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit('SET_IPP_LIST', res.data)
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    createIPPModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ipphone/add_settop_phone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        ippData: response.data.newData,
                        accountId: response.data.accountId,
                        idx: response.data.idx,
                        userId: response.data.userId
                    }
                    commit('ADD_IPP_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteIPPSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ipphone/delete_stb_phone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        ippData: postData.stbId,
                        accountId: postData.accountId
                    }
                    commit('DELETE_IPP_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    linkUserIPPSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });

            axios.post('/ipphone/link_stbphone_to_user', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (authData.userPg == true) {
                        var successData = {
                            val: authData.val,
                            id: authData.stbId,
                            accountId: authData.accountId,
                        }
                        commit('ADD_DELETE_IPP_LINK_MAC', successData)
                    } else {
                        var successData = {
                            id: authData.stbId,
                            accountId: authData.accountId,
                            linkType: authData.linkType,
                            userName: response.data.userName,
                            userId: response.data.jsonNew
                        }
                        commit('LINK_IPP_TO_USER', successData)
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    unlinkUserIPPSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ipphone/unlink_stpphone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (postData.userPg == true) {
                        var successData = {
                            id: postData.stbId,
                            accountId: postData.accountId,
                        }
                        commit('ADD_DELETE_IPP_LINK_MAC', successData)
                    } else {
                        var successData = {
                            id: postData.stbId,
                            accountId: postData.accountId,
                            linkType: postData.linkType,
                            userName: "",
                            userId: "NULL"
                        }
                        commit('LINK_IPP_TO_USER', successData)
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    changeMACIPPSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ipphone/replace_stb_phone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    importIPPSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/ipphone/import_settop_phone", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    selectedExportIPPSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ipphone/export_settop_phone', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    getIPPhoneListGetters: state => {
        return state.ipPhoneList;
    },
    getIPPhonePermissionGetters: state => {
        return state.ipPhonePermission;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}